import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import EbookLanding from './components/EbookLanding';
import OchranaSukromia from './components/OchranaSukromia';
import ZmluvnePodmienky from './components/ZmluvnePodmienky';
import TermsAndConditions from './components/TermsAndConditions';
import RefundPolicy from './components/RefundPolicy';
import PaymentPage from './components/PaymentPage';
import PaymentSuccess from './components/PaymentSuccess';
import PaymentFailed from './components/PaymentFailed';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<EbookLanding />} />
        <Route path="/payment" element={<PaymentPage />} />
        <Route path="/ochrana-sukromia" element={<OchranaSukromia />} />
        <Route path="/zmluvne-podmienky" element={<ZmluvnePodmienky />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="/refund-policy" element={<RefundPolicy />} />
        <Route path="/payment-success" element={<PaymentSuccess />} />
        <Route path="/payment-failed" element={<PaymentFailed />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
